import { render, staticRenderFns } from "./fixednav.vue?vue&type=template&id=7446853c&"
import script from "./fixednav.vue?vue&type=script&lang=js&"
export * from "./fixednav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports